import type { ReactNode } from 'react';

interface Props {
  readonly children: ReactNode;
}

const Em = ({ children }: Props) => (
  <em data-cy="lp-em" className="font-serif italic">
    {children}
  </em>
);

export default Em;
